/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { IErrorResponse, IProductCategory } from '@/types';

import { useQuery } from '@tanstack/react-query';

import { urls } from '@/statics';

const useCategories = () => {
  return useQuery<IProductCategory[], IErrorResponse>({
    queryKey: [urls.categories],
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useCategories;
